import React, { Component } from 'react';
import { FormControl, TextField, Grid, Typography } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddBox";
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import Tooltip from "@material-ui/core/Tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";
//@ts-ignore
import CSVReader from "react-csv-reader";

import InputRules from "./InputRules";
import ProxyTypes from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ProxyTypes";
import ProbabilityInput from "./ProbabilityInput";

const styles = (theme: Theme) => createStyles({
  csv: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    padding: theme.spacing(1),
    display: 'block',
    margin: '15px auto',
    border: '1px solid #ccc',
    color: '#484848'
  }
});

interface Expression {
  time_to_failure: number[],
  estimated_reliability: number[],
  _proxy: string
}

interface Props {
  timeToFailure: number[];
  estimatedReliability: number[];
  onChange: (e: any, error?: boolean, multiple?: boolean) => void;
  classes: any;
}

interface State {
  data: Expression;
  dataSetCount: number;
}

class NonParametricInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { timeToFailure, estimatedReliability } = props;

    this.state = {
      data: {
        time_to_failure: timeToFailure ? timeToFailure : [null],
        estimated_reliability: estimatedReliability ? estimatedReliability : [null],
        _proxy: ProxyTypes.NON_PARAMETRIC_DISTRIBUTION
      },
      dataSetCount:
        timeToFailure && estimatedReliability ?
          timeToFailure.length || estimatedReliability.length :
          1
    }
  }

  private handleTimeToFailureChange = async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { data: { time_to_failure } } = this.state;
    const newTimeToFailureSet = [...time_to_failure];
    console.log("target val",e.target.value)
    console.log("T TO F OG", this.state.data.time_to_failure);
    e.persist();
    const isTimeToFailureFieldValid = InputRules.isTestIntervalValid(e.target.value);
    console.log("isTimeToFail",isTimeToFailureFieldValid );
    newTimeToFailureSet[parseInt(e.target.id)] = Number(e.target.value);
    await this.setState(prevState => ({
      data: {
        ...prevState.data,
        time_to_failure: newTimeToFailureSet
      }
    })) 
    
    console.log("T TO F changed", this.state.data.time_to_failure);
    await this.callOnChange(!isTimeToFailureFieldValid);
  };

  private handleEstimatedReliabilityChange =async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { data: { estimated_reliability } } = this.state;
    const newEstimatedReliabilitySet = [...estimated_reliability];

    e.persist();
    const isEstimatedReliabilityFieldValid = InputRules.isProbabilityValid(e.target.value);
    //@ts-ignore
    newEstimatedReliabilitySet[Number(e.target.id)] = e.target.value;

    await this.setState(prevState => ({
      data: {
        ...prevState.data,
        estimated_reliability: newEstimatedReliabilitySet
      }
    }));
  console.log("SET RELIABILITY",this.state.data.estimated_reliability)
  await this.callOnChange(!isEstimatedReliabilityFieldValid)
  };

  private callOnChange = (hasError?: boolean) => {
    const { data, data: { time_to_failure, estimated_reliability } } = this.state;
    const { onChange } = this.props;
    console.log("IN CALL ON CHANGED!")
    let e = { target: { value: {} } };
    e.target.value = {
    	...data,
	    estimated_reliability: estimated_reliability.map((val: any) => Number(val)) // Cast as Number to prevent 500 error
    };

    if (
      time_to_failure.length === 0 ||
      estimated_reliability.length === 0 ||
      time_to_failure.some((val: number) => !InputRules.isTestIntervalValid(val)) ||
      estimated_reliability.some((val: number) => !InputRules.isProbabilityValid(val))
    ) {
      hasError = true;
    }

    onChange(JSON.stringify(e), hasError, true);
  };

  private setTextFields = () => {
    const { data: { time_to_failure, estimated_reliability }, dataSetCount } = this.state;
    let index = 0;
    let viewSet = [];
    while(index < dataSetCount) {
      const isTimeToFailureFieldValid = InputRules.isTestIntervalValid(time_to_failure && time_to_failure[index]);
      viewSet.push(
          <Grid item xs={6} key={`ttf-${index}`} >
            <TextField
              required
              name="time_to_failure"
              type="number"
              key={index}
              id={index.toString()}
              value={time_to_failure && time_to_failure[index]}
              onChange={this.handleTimeToFailureChange}
              error={!isTimeToFailureFieldValid}
              margin="none"
              fullWidth
              helperText={isTimeToFailureFieldValid ? undefined : InputRules.DESCRIPTIONS.TEST_INTERVAL}
            />
          </Grid>
      );
      viewSet.push(
          <Grid item xs={6} key={`er-${index}`}>
            <ProbabilityInput
              id={index.toString()}
              name="estimated_reliability"
              value={estimated_reliability && estimated_reliability[index]}
              onChange={this.handleEstimatedReliabilityChange}
            />
          </Grid>
      );
      index++;
    }
    return viewSet;
  };

  private handleAddSet = async () => {
    await this.setState(prevState => ({
      data: {
        ...prevState.data,
        time_to_failure: [...prevState.data.time_to_failure, null],
        estimated_reliability: [...prevState.data.estimated_reliability, null]
      },
      dataSetCount: prevState.dataSetCount + 1
    }));
    await this.callOnChange(true)
  };

  private handleDeleteSet =async  () => {
    const { data: { time_to_failure, estimated_reliability } } = this.state;

    let newTimeToFailureSet = [...time_to_failure];
    let newEstimatedReliabilitySet = [...estimated_reliability];

    // remove last items from both sets
    newTimeToFailureSet.splice(newTimeToFailureSet.length - 1, 1);
    newEstimatedReliabilitySet.splice(newEstimatedReliabilitySet.length - 1, 1);

    await this.setState(prevState => ({
      data: {
        ...prevState.data,
        time_to_failure: newTimeToFailureSet,
        estimated_reliability: newEstimatedReliabilitySet
      },
      dataSetCount: Math.max(prevState.dataSetCount - 1, 0) // decrement by 1, but don't set less than 0
    }));
    await this.callOnChange();
  };

  private handleCSV = async (data: any) => {
    let validData = data.filter((x: any) => x.length > 1); // CSV should have at least 2 cols
    validData = validData.map((x: any) => x.slice(0, 2)); // Get first 2 cols

    let timeToFailureSet: any = [];
    let estimatedReliabilitySet: any = [];

    // Populate sets
    validData.forEach((array: any) => {
      array.forEach((item: any, i: any) => {
        if (i === 0) {
          if (InputRules.isTestIntervalValid(item)) {
            timeToFailureSet.push(Number(item));
          } else {
            timeToFailureSet.push("");
          }
        } else {
          if (InputRules.isProbabilityValid(item)) {
            estimatedReliabilitySet.push(Number(item));
          } else {
            estimatedReliabilitySet.push("");
          }
        }
      })
    });

    await this.setState(state => ({
      data: {
        ...state.data,
        time_to_failure: timeToFailureSet,
        estimated_reliability: estimatedReliabilitySet
      },
      dataSetCount: timeToFailureSet.length || estimatedReliabilitySet.length
    }))
    await this.callOnChange()
  };

  private handleCSVError = (error: any) => {
    console.error(error);
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container spacing={10} alignItems="flex-start">
        <Grid item xs={12}>
          <CSVReader
            cssClass={classes.csv}
            label="Import CSV"
            onFileLoaded={this.handleCSV}
            onError={this.handleCSVError}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption">Time</Typography>
        </Grid>
        <Grid item xs={6} >
          <Typography variant="caption">Reliability</Typography>
        </Grid>
        {this.setTextFields()}
        <Grid item xs={12}>
          <Grid container justify="flex-end">
            <Tooltip title="Add to Set">
              <IconButton onClick={this.handleAddSet}>
                <AddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Remove from Set">
              <IconButton onClick={this.handleDeleteSet}>
                <IndeterminateCheckBoxIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(NonParametricInput);
